import { DateColProps, NO_DATA_INFO } from '../../../types';

const CollapsedDateCol = (props: DateColProps): JSX.Element => {
    const { date } = props;
    return <>{date ? <span>{date}</span> : <span className={'text-color-lighter'}>{NO_DATA_INFO}</span>}</>;
};

export default CollapsedDateCol;
